import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import Config from '../utils/config.service';

@Injectable({ providedIn: 'root' })
export default class PreVisitTicketFileService {
	private httpClient: HttpClient = inject(HttpClient);
	private config: Config = inject(Config);

	uploadPrevisitPicture(userId, file, onSuccess, onError) {
		var formData: any = new FormData();
		formData.append('file', file);
		this.httpClient.post(this.config.getRestUrl() + 'rest/previsit/ticket/file/user/' + userId + '/picture/' + file.name, formData, {
			withCredentials: true
		})
		.subscribe(
			(response) => {
				onSuccess(response);
			},
			(err) => {
				onError(err);
			}
		);
	}
	
	deletePrevisitPicture(fileId, onSuccess, onError) {
		this.httpClient.delete(this.config.getRestUrl() + 'rest/previsit/ticket/file/' + fileId, {
			withCredentials: true
		})
		.subscribe(
			(response) => {
				onSuccess(response);
			},
			(err) => {
				onError(err);
			}
		);
	}
	
}